<!-- Deploy -->
<div class="app-wrapper">
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
